import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#05050A] flex items-center justify-center">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export const CoachProtectedRoute = ({ children }) => {
  const { coach, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#05050A] flex items-center justify-center">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!coach) {
    return <Navigate to="/coach/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
